export default {
  props: {
    fields: {
      type: Array,
    },
    data: {
      type: Object,
    },
  },
  render() {
    return (
      <div>
        {this.fields.map((item) => {
          return (
            <div style="display: flex; flex-wrap: wrap;">
              <div style="padding-right: 10px; text-align: right; line-height: 1.5rem; width: 45%; flex: 0 0 45%;">
                {item.label}
              </div>
              {(this.data[item.key] || item.render) && (
                <div style="padding-left: 10px; text-align: left; line-height: 1.5rem; width: 55%; flex: 0 0 55%;">
                  {item.render
                    ? item.render(
                        this.$createElement,
                        this.data[item.key] || undefined,
                        this.data
                      )
                    : this.data[item.key]}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  },
};
